import { render, staticRenderFns } from "./macrotrend.vue?vue&type=template&id=18709f02"
import script from "./macrotrend.vue?vue&type=script&lang=js"
export * from "./macrotrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./macrotrend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports